module.exports = __webpack_public_path__ + "img/sport-game.2ee33912.png";